import { TFunction, i18n } from 'i18next'

type TI18nKey = string | string[]

let addTranslationCallback:
  | ((key: TI18nKey, translation: string) => void)
  | null = null

export const setI18nInterceptorCallback = (
  callback: (key: TI18nKey, translation: string) => void,
) => {
  addTranslationCallback = callback
}

export const i18nInterceptor = (i18nInstance: i18n): void => {
  const originalT = i18nInstance.t.bind(i18nInstance)

  i18nInstance.t = ((key: TI18nKey, options?: any) => {
    const translation = originalT(key, options)

    if (addTranslationCallback) {
      let resolvedKey = key

      if (options?.context) {
        resolvedKey = Array.isArray(key)
          ? key.map((item) => `${item}_${options.context}`)
          : `${key}_${options.context}`
      }

      addTranslationCallback(resolvedKey, translation as string)
    }

    return translation
  }) as TFunction
}
